import axios from 'axios'
import { BASE_URL } from '../../utils/constants/url'
import generalHeader from '../../utils/constants/generalHeader'

const sendResetPasswordEmail = async (data) => {
  const url = `${BASE_URL}/auth/send-reset-password-email`

  return axios.post(url, data, {
    headers: generalHeader(),
  })
}

export default sendResetPasswordEmail
